export default "__VITE_ASSET__CqhMOAdg__"